"use client";

import Script from "next/script";

const META_PIXEL_ID = "911483278494201";

/**
 * Meta Pixel (Facebook Pixel) Component
 * Tracks page views and conversions for Facebook/Instagram ads
 * Works alongside Conversions API for server-side tracking
 */
export function MetaPixel() {
	return (
		<>
			<Script
				id="meta-pixel"
				strategy="afterInteractive"
				// biome-ignore lint/security/noDangerouslySetInnerHtml: Meta Pixel SDK requires inline script.
				dangerouslySetInnerHTML={{
					__html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${META_PIXEL_ID}');
            fbq('track', 'PageView');
          `,
				}}
			/>
			<noscript>
				{/* biome-ignore lint/performance/noImgElement: Tracking pixel requires native img for noscript fallback */}
				<img
					height="1"
					width="1"
					style={{ display: "none" }}
					src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
					alt=""
				/>
			</noscript>
		</>
	);
}
